module.exports = __webpack_public_path__ + "static/nad-e768138b5c9fbdf8cca61d2e20890959.png";